import React from "react";
import {
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { Field } from "redux-form";
import { properCase } from "LIB/formatters/text";
import { connect } from "react-redux";
import * as actions from "MODULES/users/actions";
import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import { onSuccess } from "LIB/submission";

const formName = "verifyEmail";

function Form(props) {
  const submit = onSuccess(props.handleSubmit, props.close, props);

  return (
    <AppForm {...props} onSubmit={submit}>
      <AppForm.Body>
        <FormRow>
          <Col md={12}>
            <Field
              name={"token"}
              component={FormInput}
              label={properCase("token")}
              required
            />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, { onSubmit: actions.verify })(
  form({
    form: formName,
    validate: values =>
      validator(values, f => {
        f.validate("token").satisfies(rules.required);
      })
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/users/components/VerifyEmail/Form.jsx